import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faBottleWater,
  faBowlFood,
  faBowlRice,
  faBoxOpen,
  faBurger,
  faCakeCandles,
  faCookieBite,
  faDrumstickBite,
  faFire,
  faFish,
  faGift,
  faHotdog,
  faJar,
  faLeaf,
  faMartiniGlassCitrus,
  faMugHot,
  faPizzaSlice,
  faShrimp,
  faUtensils,
  faWineGlass,
} from '@fortawesome/free-solid-svg-icons'

const RULES: [RegExp, IconDefinition][] = [
  [/ofert|promo|special|акци/, faGift],
  [/wok|вок/, faBowlFood],
  [/poke|bowl|боул/, faLeaf],
  [/tempura|темпур/, faShrimp],
  [/coapt|запеч|baked/, faFire],
  [/gunkan|guncan|гункан/, faBowlRice],
  [/desert|dulc|tort|десерт|торт/, faCakeCandles],
  [/burger|бургер/, faBurger],
  [/\bset|сет/, faBoxOpen],
  [/rol|ролл/, faFish],
  [/sushi|суши/, faFish],
  [/pizza|пицц/, faPizzaSlice],
  [/tom yam|том ям|\bsup|суп|ramen|рамен/, faMugHot],
  [/fast|фаст|cartofi|картоф/, faHotdog],
  [/cocktail|коктейл/, faMartiniGlassCitrus],
  [/non.?alcool|безалког/, faBottleWater],
  [/alcool|алкогол|\bvin|\bbere|пив/, faWineGlass],
  [/băutur|bautur|напит|drink|\bsuc/, faBottleWater],
  [/\bsos|соус/, faJar],
  [/salat|салат/, faLeaf],
  [/carne|grill|гриль|мяс/, faDrumstickBite],
  [/pește|peste|рыб/, faFish],
  [/gustăr|gustar|canap|закуск|канап/, faCookieBite],
  [/food|mânc|еда/, faUtensils],
]

export function categoryIcon(name = ''): IconDefinition {
  const value = name.toLowerCase()
  return RULES.find(([pattern]) => pattern.test(value))?.[1] ?? faUtensils
}
